import { openDB } from "idb";
import { clearCache } from "./cacheManager";
import { DidTimeExpired, cacheKeysExists, clearPageDB } from "./utils";
export const openIdb = (dbName, storeName, dbVersion, slugKey, strictKeys = false) => {
  const dbPromise = openDB(dbName, dbVersion, {
    upgrade(db) {
      db.createObjectStore(storeName);
    },
  });

  return {
    get: async function (key) {
      if (localStorage.getItem("last_data_version") != localStorage.getItem("data_version")) {
        clearPageDB();
        clearCache();
        localStorage.setItem("last_data_version", localStorage.getItem("data_version"));
      }
      let cacheData = await (await dbPromise).get(
        storeName,
        key + "_" + slugKey
      );
      if (
        typeof cacheData != "undefined" &&
        typeof cacheData.createDate != "undefined"
      ) {
        if (
          DidTimeExpired(cacheData.createDate, cacheData.expiry)["expired"] ===
          false
        ) {
          return cacheData.value;
        } else {
          (await dbPromise).delete(storeName, key + "_" + slugKey);
          return null;
        }
      }
    },
    set: async function (key, value, expiry) {
      try {
        if (strictKeys === true && cacheKeysExists(key) === false) {
          throw "Trying to set an invalid cache Key.";
        } else {
          let currentDate = new Date();
          return (await dbPromise).put(
            storeName,
            {
              value: value,
              createDate:
                currentDate.getFullYear() +
                "_" +
                currentDate.getMonth() +
                "_" +
                currentDate.getDate() +
                "_" +
                currentDate.getHours() +
                "_" +
                currentDate.getMinutes() +
                "_" +
                currentDate.getSeconds(),
              expiry: expiry,
            },
            key + "_" + slugKey
          );
        }
      } catch (error) {
        alert(error);
      }
    },
    del: async function (key) {
      return (await dbPromise).delete(storeName, key + "_" + slugKey);
    },
    clear: async function () {
      return (await dbPromise).clear(storeName);
    },
    keys: async function () {
      return (await dbPromise).getAllKeys(storeName);
    },
  };
};
